import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

type State = {
  selectedCountry: string | undefined;
  countryOptions: string[];
};

const initial: State = {
  selectedCountry: undefined,
  countryOptions: [],
};

const store = create<State>(() => ({
  ...initial,
}));

export const useCountryAdminStore = createSelectorHooks(store);
